exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-padding[data-v-750440a6]{padding-left:10%;padding-right:10%}.common-card[data-v-750440a6]{border-radius:.16rem;padding:.32rem .24rem}.exchange-detail .detail-title-1[data-v-750440a6]{margin-bottom:.24rem}.exchange-detail .td-type-img[data-v-750440a6]{width:.52rem;margin-right:.16rem}.search-form[data-v-750440a6]{justify-content:end}", ""]);

// exports
